<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body class="form-card mt-3">
          <!-- search bar -->
          <b-row class="mb-2 px-3 mt-3">
            <b-col cols="12" lg="4" align-self="center">
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'users']" fixed-width size="lg" />
                <p class="mb-0 mx-2 fs-20 table-capt">
                  Miembros del grupo
                  <b-badge style="background-color: #F1F2F4; color: black;">
                    {{ groupMembers.length }}
                  </b-badge>
                </p>
              </div>
            </b-col>
            <b-col align-self="center">
              <b-form-group class="mb-0">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" @click="searchMember">
                      <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                    </b-button>
                  </b-input-group-prepend>
                  <b-input
                    v-model="searchTerm"
                    autofocus
                    placeholder="Nuevos miembros: Buscar por nombre, apellido o correo"
                    @keydown.enter="searchMember"
                  />
                  <b-input-group-append class="ml-3">
                    <b-button variant="outline-secondary" @click="resetMemberSearch">
                      <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
            :items="availableMembers"
            :fields="fields"
            primary-key="id"
            class="fs-15 mb-0"
            show-empty
            caption-top
            hover
          >
            <template #empty>
              <div v-if="loadingMembers" class="text-center text-secondary">
                <b-spinner small type="grow"></b-spinner>
                <span class="pl-2 fs-18">Consultando...</span>
              </div>
              <div v-else class="text-center font-italic">
                <span v-if="searchTerm" class="text-danger fs-18">No hay resultados</span>
                <span v-else class="text-secondary fs-18">No hay datos para mostrar</span>
              </div>
            </template>

            <template #cell(state)="data">
              <template v-if="data.item.alreadyAdded">
                <b-spinner v-if="processingMember && data.item.id == selectedMemberId" small type="grow" class="text-info"></b-spinner>
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'check-square']"
                  size="lg"
                  fixed-width
                  class="text-primary clickable"
                  @click="removeMember(data.item)"
                />
              </template>
              <template v-else>
                <b-spinner v-if="processingMember && data.item.id == selectedMemberId" small type="grow" class="text-info"></b-spinner>
                <font-awesome-icon
                  v-else
                  :icon="['far', 'square']"
                  size="lg"
                  fixed-width
                  class="clickable"
                  @click="addMember(data.item)"
                />
              </template>
            </template>

            <template #cell(user)="data">
              <div v-if="data.item.alreadyAdded" class="name-container">
                <p class="mb-0" style="line-height: 11px;">{{ data.value | concatName4 }}</p>
                <p v-if="data.item.user.email" class="text-muted mb-0">{{ data.item.user.email}}</p>
              </div>
              <div v-else class="name-container">
                <p class="mb-0" style="line-height: 11px;">{{ data.item | concatName4 }}</p>
                <p v-if="data.item.email" class="text-muted mb-0">{{ data.item.email }}</p>
              </div>
            </template>

            <template #cell(role)="data">
              <b-dropdown
                v-if="data.item.alreadyAdded"
                id="roleItem"
                ref="roleItem"
                size="sm"
                variant="outline-secondary"
                :text="roleMap[data.value]"
                style="width: 70px;"
                class="fs-17"
              >
                <b-dropdown-item
                  v-for="role in roleOptions" :key="role.value"
                  :active="data.value == role.value"
                  class="p-0 m-0 fs-17"
                  @click="updateRoleMember(data.item, role.value)"
                >
                  <span>{{role.text}}</span>
                </b-dropdown-item>
              </b-dropdown>
              <b-dropdown
                v-else
                v-model="newMemberForm.role"
                id="roleItemNew"
                ref="roleItemNew"
                size="sm"
                variant="outline-secondary"
                :text="roleMap[newMemberForm.role] || 'Seleccione un rol'"
                style="width: 70px;"
                class="fs-17"
              >
                <b-dropdown-item
                  v-for="role in roleOptions" :key="role.value"
                  :active="data.value == role.value"
                  class="p-0 m-0 fs-17"
                  @click="setNewRole(role.value)"
                >
                  <span>{{role.text}}</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'GroupMembersTable',
  components: { },
  props: {
    filterForm: {
      type: Object,
      required: true
    },
    selectedGroupId: {
      type: String | Number | null,
      required: true
    }
  },
  data () {
    return {
      loadingMembers: false,
      groupMembers: [],
      filterTerm: '',
      roleOptions: [
        { value: 'requester', text: 'Solicitante' },
        { value: 'approver', text: 'Aprobador' },
        { value: 'both', text: 'Aprobador | Solicitante' }
      ],
      roleMap: {
        requester: 'Solicitante',
        approver: 'Aprobador',
        both: 'Aprobador | Solicitante'
      },
      searchTerm: '',
      fields: [
        { key: 'state', label: '', tdClass: 'align-middle text-center', thClass: 'text-center', thStyle: { width: '36px' }},
        { key: 'user', label: 'Miembro', tdClass: 'align-middle', thClass: '' },
        { key: 'role', label: 'Role', tdClass: 'align-middle text-center', thClass: 'text-center', sortable: true, thStyle: { width: '300px' } }
      ],
      newMemberForm: {
        role: 'requester'
      },
      processingMember: false,
      selectedMemberId: null,
      resultMembers: [],
      searchMembersEmpty: false,
    }
  },
  watch: {
    selectedGroupId (newVal, oldVal) {
      if (newVal === 'reset') {
        this.resetState()
      } else {
        this.fetchMembers()
      }
    }
  },
  computed: {
    availableMembers () {
      if (this.resultMembers.length > 0) {
        const memberUserIds = this.groupMembers.map(member => member.user_id)

        return this.resultMembers.map(user => {
          if (memberUserIds.includes(user.id)) {
            const member = this.groupMembers.find(m => m.user_id === user.id)
            return {
              ...member,
              alreadyAdded: true
            }
          } else {
            return {...user, alreadyAdded: false }
          }
        })
      }

      if (this.searchTerm && this.searchMembersEmpty) return []

      return this.groupMembers.map(member => ({...member, alreadyAdded: true }))
    }
  },
  methods: {
    fetchMembers() {
      if (this.loadingMembers) return
      this.loadingMembers = true
      this.searchTerm = ''
      this.$http.get(`/api/approval_groups/${this.filterForm.selectedGroupId}/approval_group_members`)
        .then(response => {
          // console.log(response.data)
          this.groupMembers = response.data
        })
        .catch(error => {
          // console.log(error)
          this.groupMembers = []
        })
        .finally(() => {
          this.loadingMembers = false
        })
    },
    searchMember () {
      if (!this.searchTerm.length) {
        this.resultMembers = []
        this.searchMembersEmpty = false
        return
      }

      if (this.loadingMembers) { return }
      const term = this.normalizeString(this.searchTerm)
      this.loadingMembers = true
      this.$http.get(`/api/human_resources/users/advanced_search`, {
          params: {
            q: term
          }
        })
        .then(response => {
          // console.log(response)
          this.resultMembers = response.data
          this.searchMembersEmpty = this.resultMembers.length === 0
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          this.loadingMembers = false
        })
    },
    resetMemberSearch () {
      this.searchTerm = ''
      this.resultMembers = []
      this.searchMembersEmpty = []
      this.selectedMemberId = null
    },
    addMember (userToAdd) {
      if (this.processingMember) return
      this.processingMember = true
      this.selectedMemberId = userToAdd.id
      this.$http.post(`/api/approval_groups/${this.filterForm.selectedGroupId}/approval_group_members`, {
        approval_group_member: {
          user_id: userToAdd.id,
          role: this.newMemberForm.role
        }
      })
        .then(response => {
          this.groupMembers.push(response.data)
          this.newMemberForm.role = 'requester'
        })
        .catch(error => {
          // console.log(error)
          let message = error.response?.data?.error || ''
          if (message.includes('El usuario ya es solicitante en el grupo')) {
            message = message.split("La validación falló: ")[1]
          }
          this.$emit('display-alert', {
            variant: 'danger',
            message: message || 'Hubo un error al agregar el usuario, intente nuevamente'
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.processingMember = false
            this.selectedMemberId = null
          }, 500)
        })
    },
    removeMember (member) {
      if (this.processingMember) return
      this.processingMember = true
      this.selectedMemberId = member.id
      this.$http.delete(`/api/approval_groups/${member.approval_group_id}/approval_group_members/${member.id}`)
        .then(response => {
          const updatedMember = response.data
          const index = this.groupMembers.findIndex(r => r.id === updatedMember.id)
          if (index === -1) return

          this.groupMembers.splice(index, 1)
        })
        .catch(error => {
          this.$emit('display-alert', {
            variant: 'danger',
            message: 'Hubo un error al eliminar el miembro, intente nuevamente'
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.processingMember = false
            this.selectedMemberId = null
          }, 500)
        })
    },
    setNewRole (value) {
      this.newMemberForm.role = value
    },
    updateRoleMember (member, role) {
      this.$http.patch(`/api/approval_groups/${member.approval_group_id}/approval_group_members/${member.id}`, {
        approval_group_member: {
          role: role
        }
      })
        .then(response => {
          // console.log(response)
          const updatedMember = response.data
          const index = this.groupMembers.findIndex(r => r.id === updatedMember.id)
          if (index === -1) return

          this.groupMembers[index].role = updatedMember.role
        })
        .catch(error => {
          const message = error.response?.data?.error || ''
          if (message.includes('El usuario ya es solicitante')) {
            return this.$emit('display-alert', {
              variant: 'danger',
              message
            })
          }

          this.$emit('display-alert', {
            variant: 'danger',
            message: 'Hubo un error al actualizar el role, intente nuevamente'
          })
        })
    },
    resetState () {
      this.groupMembers = []
      this.resultMembers = []
      this.searchMembersEmpty = false
      this.filterTerm = ''
      this.selectedMemberId = null
    },
    normalizeString (str) {
      return str?.toString()
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, " ") // replace multiple spaces with one
                  .replace(/[áÁ]/g, 'a')
                  .replace(/[éÉ]/g, 'e')
                  .replace(/[íÍ]/g, 'i')
                  .replace(/[óÓ]/g, 'o')
                  .replace(/[úÚ]/g, 'u')
    }
  }
}
</script>

<style scoped>
  .form-card {
    border-radius: 8px;
    /* padding: 10px 15px; */
    border: 2px solid #e2e8f0;
    min-height: 100px;
  }
  @media (max-width: 991.98px) {
    .table-capt {
      font-size: 1.25rem;
    }
    .name-container p {
      font-size: 0.875rem;
    }
  }
</style>